import type { Route } from '@angular/router';
import { dirtyCheckCanDeactivateGuard } from '../../../common/dirty-check/dirty-check';
import {
  hasPathParamCanActivateGuard,
  hasStringPathParamCanActivateGuard,
} from '@pct/ng-core-router';
import { FIX_LOCATION_CATEGORY_IDS } from './fix-categories';
import { isString } from '@pct/ts-typeguard';

export const locationsCategoryRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/locations-category-list.component'),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () => import('../../../common/category-details/category-details.component'),
    title: 'PAGES.LOCATION.CATEGORY.BREADCRUMB.NEW',
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () => import('../../../common/category-details/category-details.component'),
    title: 'PAGES.LOCATION.CATEGORY.BREADCRUMB.EDIT',
    canActivate: [
      hasStringPathParamCanActivateGuard('id'),
      hasPathParamCanActivateGuard(
        'id',
        id => isString(id) && !FIX_LOCATION_CATEGORY_IDS.includes(id),
      ),
    ],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
